/**
 * SliderDotsContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';

/**
 * Styled container for the slider pagination dots elements.
 */
const SliderDotsContainer = styled.div<React.CSSProperties>`
  display: flex;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.5));
  -webkit-filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.5));
  flex-direction: row;
  justify-content: center;
  position: absolute;
  top: ${476 * Screen.widthRatio}px;
  width: ${1920 * Screen.widthRatio}px;
  & > *:first-child {
    margin-right: ${4 * Screen.widthRatio}px;
  }
  & > *:last-child {
    margin-left: ${4 * Screen.widthRatio}px;
  }
  & > *:not(:first-child):not(:last-child) {
    margin-left: ${4 * Screen.widthRatio}px;
    margin-right: ${4 * Screen.widthRatio}px;
  }
`;
export default SliderDotsContainer;
